import { createSelector } from 'reselect';
import { enableLMSStoreAPISelector } from 'selectors/testTarget/offers/lmsApi/lmsStoreAPI/enableLMSStoreAPISelector';

const showSelector = createSelector(enableLMSStoreAPISelector, enableLMSStoreAPI => !!enableLMSStoreAPI);

export { showSelector };
